module.exports = __webpack_public_path__ + "static/img/amy3.da37b6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Parts/Key3D/cdp/amy3.jpg
// module id = 29
// module chunks = 0